import { render, staticRenderFns } from "./BlockContainer.vue?vue&type=template&id=bee62738"
import script from "./BlockContainer.vue?vue&type=script&lang=js"
export * from "./BlockContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports